import customSelect from 'custom-select';
customSelect('.slider-select select');

customSelect('.research-tools select');
customSelect('.jump_list-block select');
